/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {AsideMenuItemWithSubMain} from './AsideMenuItemWithSubMain'
import {AsideMenuItem} from './AsideMenuItem'
import {useAuth} from '../../../../app/modules/auth'
import {useEffect, useState} from 'react'
import {listUserClaim} from '../../../../app/modules/auth/core/_requests'

type ClaimType = {
  id: number
  name: string
  operationClaimId: number
  hasSubUnit: boolean
}

export function ManagementAsideMenuMain() {
  const {currentUser} = useAuth()
  const intl = useIntl()
  const [userClaim, setUserClaim] = useState<ClaimType[]>([])

  useEffect(() => {
    getClaim()
  }, [])

  const getClaim = async () => {
    try {
      const {data} = await listUserClaim(Number(currentUser?.id))
      setUserClaim(data)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      <AsideMenuItem
        to='/management/dashboard'
        title={intl.formatMessage({id: 'SLIDEMENU.HOME'})}
        fontIcon='bi-house fs-2'
        bsTitle={intl.formatMessage({id: 'SLIDEMENU.HOME'})}
        className='py-2'
      />
      {userClaim.some((claim) => claim.operationClaimId === 1 || claim.operationClaimId === 2) && (
        /*
              <AsideMenuItem
            to='/management/users'
            title={intl.formatMessage({id: 'MENU.ADMIN_PANEL'})}
            bsTitle={intl.formatMessage({id: 'MENU.ADMIN_PANEL'})}
            fontIcon='bi-people fs-2'
            className='py-2'
          />
         */
        <AsideMenuItemWithSubMain
          to='/management/users'
          title={intl.formatMessage({id: 'MENU.ADMIN_PANEL'})}
          bsTitle={intl.formatMessage({id: 'MENU.ADMIN_PANEL'})}
          fontIcon='bi-people fs-2'
        >
          <AsideMenuItem
            to='/management/users'
            title={intl.formatMessage({id: 'MENU.ADMIN_PANEL'})}
            hasBullet={true}
          />
          <AsideMenuItem
            to='/management/references-code'
            title={intl.formatMessage({id: 'MENU.REFERENCES_CODE'})}
            hasBullet={true}
          />
        </AsideMenuItemWithSubMain>
      )}

      <AsideMenuItemWithSubMain
        to='/management/all-device'
        title={intl.formatMessage({id: 'MENU.ALL_DEVICE'})}
        bsTitle={intl.formatMessage({id: 'MENU.ALL_DEVICE'})}
        fontIcon='bi-cpu fs-2'
      >
        <AsideMenuItem
          to='/management/all-device/device'
          title={intl.formatMessage({id: 'MENU.ALL_DEVICE.DEVICE'})}
          hasBullet={true}
        />
        <AsideMenuItem
          to='/management/all-device/device-groups'
          title={intl.formatMessage({id: 'MENU.ALL_DEVICE.DEVICE_GROUPS'})}
          hasBullet={true}
        />
        <AsideMenuItem
          to='/management/all-device/device-types'
          title={intl.formatMessage({id: 'MENU.ALL_DEVICE.DEVICE_TYPES'})}
          hasBullet={true}
        />
      </AsideMenuItemWithSubMain>

      <AsideMenuItem
        to='/management/experiment/'
        title={intl.formatMessage({id: 'MENU.EXPERIMENT'})}
        fontIcon='bi-inbox fs-2'
      />
      <AsideMenuItem
        to='/management/category'
        title={intl.formatMessage({id: 'MENU.CATEGORY'})}
        fontIcon='bi-bookmark fs-2'
      />
      <AsideMenuItem
        to='/management/content'
        title={intl.formatMessage({id: 'MENU.CONTENT'})}
        fontIcon='bi-body-text fs-2'
      />
      <AsideMenuItem
        to='/management/unit'
        title={intl.formatMessage({id: 'MENU.UNIT'})}
        fontIcon='bi-building fs-2'
      />
      <AsideMenuItem
        to='/management/smr-topic'
        title={intl.formatMessage({id: 'MENU.SMRTOPIC'})}
        fontIcon='bi-phone fs-2'
      />
      <AsideMenuItem
        to='/management/setup-stepmotor'
        title={`Setup Stepmotor`}
        fontIcon='bi-gear-wide-connected fs-2'
      />
      <AsideMenuItem to='/management/codap' title={`Codap`} />
    </>
  )
}
